import { SubscriptionPlanOption } from './options/subscription-plan'
import { StatusOption } from './options/status'

export const options = [StatusOption, SubscriptionPlanOption]
